import { Link, redirect, usePathname, useRouter } from './i18n/navigation';

// Re-export for existing imports across the project
export const BaseLink = Link;
export { redirect, usePathname, useRouter };
